import { User } from "~/types/auth/auth.types";
import { CreateMemberInput } from "~/types/user/user.types";

import { sendRequest } from "../clients/axios";

export const signupUser = async (input: CreateMemberInput) => {
  const res = await sendRequest<
    CreateMemberInput,
    User & { intent: { client_secret: string } }
  >({
    method: "post",
    url: "/auth/signup",
    data: input,
  });
  return res.data;
};
